import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import BasicButton from '@web-ui-kit/basic-button'
import Text from '@web-ui-kit/text'
import { getUrlParams, goToLoginPage } from '../../utils'
import * as Sc from './SessionError.style'
import { IconLogout } from 'assets/icons/IconLogout'
import { sendLogout } from 'api/user'
import { ROUTES } from 'routes/paths'
import { updateError } from 'store/actions/drawer.actions'
import { grafanaUtils } from 'utils/Grafana'
import { GRAFANA_VIEWS } from 'utils/constants'
const SessionError = () => {
  const { i18n, t } = useTranslation()
  const { push } = useHistory()
  const { errorHandling } = useSelector(({ drawer }) => drawer)
  const dispatch = useDispatch()
  const language = getUrlParams('lang')

  useEffect(() => {
    grafanaUtils.setView(GRAFANA_VIEWS.SESSION_ERROR)
    const callLogout = async () => {
      await sendLogout()
    }

    i18n.changeLanguage(language)
    if (errorHandling) {
      callLogout()
      dispatch(updateError())
    } else {
      push(ROUTES.HOME)
    }
  }, [])

  return (
    <Sc.Wrapper data-testid='wrapperSessionError'>
      <Sc.Container>
        <Sc.ContentInfo>
          <IconLogout />
          <Text bold variant='title4'>
            {t('Se ha cerrado tu sesión')}
          </Text>
          <Text variant='body'>
            {t(
              'Este usuario está siendo utilizado de forma simultánea en otro dispositivo Para seguir navegando por Edubook vuelve a iniciar sesión'
            )}
          </Text>
        </Sc.ContentInfo>

        <BasicButton
          dataTestId='loginSessionError'
          label={t('Iniciar Sesión')}
          onClick={() => goToLoginPage({ language })}
        />
      </Sc.Container>
    </Sc.Wrapper>
  )
}

export default SessionError
